import { render, staticRenderFns } from "./showResultsQuestionary.vue?vue&type=template&id=53de3177&"
import script from "./showResultsQuestionary.vue?vue&type=script&lang=js&"
export * from "./showResultsQuestionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports